import { Box, Grid, Pagination, useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ProjectSearchType } from "../../../../api/psc";
import {
    EmptyListMessage,
    EndOfInfiniteListMessage,
    PageWithFilter,
} from "../../../../components/exports";
import FilteredPage from "../../../../components/shared/FilteredPage";
import { defaultLimit } from "../../../../constants/GlobalConstants";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import DesktopProjectToolbox from "../../components/DesktopProjectToolbox";
import MobileProjectToolbox from "../../components/MobileProjectToolbox";
import ProjectItem from "../../components/ProjectItem";
import PromotedProjectFilter from "../../components/PromotedProjectFilter";
import {
    FetchPromotedProjects,
    PromotedProjectState,
    setPromotedProjectFilter,
    setPromotedProjectsPage,
} from "../../slice/PromotedProjectSlice";

type TProps = {
    isSmallOrDownScreen: boolean;
    fetch: () => void;
    onProjectTypeChange: (type: ProjectSearchType) => void;
    promotedState: PromotedProjectState;
    handlePageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
};

export default function PromotedProjectsView() {
    const dispatch = useDispatch();
    const promotedState = useAppSelector((state) => state.promoted);

    const theme = useTheme();
    const isSmallOrDownScreen = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        fetch();
    }, [promotedState.id]);

    const fetch = (page?: number) => {
        FetchPromotedProjects(promotedState, dispatch);
    };

    const handlePageChange = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        dispatch(setPromotedProjectsPage(page - 1));
        fetch(page - 1);
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const onProjectTypeChange = (type: ProjectSearchType) => {
        dispatch(
            setPromotedProjectFilter({ ...promotedState.filter, type: type })
        );
    };

    return (
        <Box sx={{ overflow: "auto", height: "100%" }}>
            <PageWithFilter filter={<PromotedProjectFilter />}>
                <FilteredPage>
                    {isSmallOrDownScreen ? (
                        <MobileProjectToolbox
                            fetchProjects={fetch}
                            setProjectType={onProjectTypeChange}
                            filterElement={<PromotedProjectFilter />}
                            isRequirements={true}
                            state={promotedState}
                        />
                    ) : (
                        <DesktopProjectToolbox
                            state={promotedState}
                            fetchProjects={fetch}
                            isRequirements={true}
                            setProjectType={onProjectTypeChange}
                        />
                    )}

                    {!promotedState.isLoading &&
                        promotedState.projects.length === 0 && (
                            <EmptyListMessage message="پروژه ای یافت نشد" />
                        )}

                    {promotedState.projects.length > 0 && (
                        <>
                            <Grid container spacing={2}>
                                {promotedState.projects.map((p) => {
                                    return (
                                        <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            md={6}
                                            lg={4}
                                            xl={3}
                                            key={p.requirement?.id ?? p.hashId}
                                        >
                                            <ProjectItem
                                                isLoading={
                                                    promotedState.isLoading
                                                }
                                                project={p}
                                            />
                                        </Grid>
                                    );
                                })}
                            </Grid>

                            {promotedState.totalCount > defaultLimit ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        mt: 2,
                                    }}
                                >
                                    <Pagination
                                        count={Math.ceil(
                                            promotedState.totalCount /
                                                defaultLimit
                                        )}
                                        color="primary"
                                        page={promotedState.page + 1}
                                        onChange={handlePageChange}
                                    />
                                </Box>
                            ) : (
                                <EndOfInfiniteListMessage />
                            )}
                        </>
                    )}
                </FilteredPage>
            </PageWithFilter>
        </Box>
    );
}
